<!-- src/components/new-tip/KpiCard.vue -->
<template>
  <v-card outlined class="kpi-card" :loading="loading">
    <v-card-text class="py-3">
      <div class="d-flex align-center">
        <v-icon v-if="icon" :color="iconColor" class="mr-3" large>{{ icon }}</v-icon>
        <div>
          <div class="text-caption text-uppercase grey--text">{{ label }}</div>
          <div class="text-h5 font-weight-medium">
            <span v-if="loading">…</span>
            <span v-else>{{ formattedValue }}</span>
            <span v-if="suffix" class="text-body-2 ml-1 grey--text">{{ suffix }}</span>
          </div>
          <div v-if="hint" class="text-caption grey--text mt-1">{{ hint }}</div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatNumber } from '@/helpers/formatters';

export default {
  name: 'NewTipKpiCard',
  props: {
    label: { type: String, required: true },
    value: { type: [Number, String], default: null },
    suffix: { type: String, default: '' },
    hint:   { type: String, default: '' },
    icon:   { type: String, default: '' },
    iconColor: { type: String, default: 'primary' },
    loading: { type: Boolean, default: false },
    isPercentage: { type: Boolean, default: false },
  },
  computed: {
    formattedValue() {
      if (this.value === null || this.value === undefined) return '—';
      if (this.isPercentage) return `${this.value}%`;
      if (typeof this.value === 'number') return formatNumber(this.value);
      return this.value;
    },
  },
};
</script>

<style scoped>
.kpi-card { transition: box-shadow 0.2s; }
.kpi-card:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important; }
</style>
